import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Mousetrap from 'mousetrap';
import { toggleFullscreen } from '../actions/PageActions';

const Kiosk = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    Mousetrap.bind(['alt+shift+enter'], () => dispatch(toggleFullscreen()));
    return () => {
      Mousetrap.unbind(['alt+shift+enter']);
    };
  });

  return (
    <div className="fullscreen-toolbar">
      <div className="curtain-button" title="Exit Fullscreen" onClick={() => dispatch(toggleFullscreen(false))}>
        <i className="fas fa-compress-arrows-alt" />
      </div>
    </div>
  );
};

export default Kiosk;
